import React from 'react';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import * as commonApi from '../../../api/common-api';
import axios from 'axios';

var querystring = require('querystring');

const styles = {
    iconStyle: {
        width: '15px',
        height: '15px',
        marginRight: '3px'
    },
    labelStyle: {
        lineHeight: '15px',
        fontFamily: 'inherit',
        fontSize: '9pt',
        fontWeight: 'normal',
        color: '#000',
        paddingTop: '-1px',
        width: 'auto'
    },
};

const grayStyles = {
    iconStyle: {
        width: '15px',
        height: '15px',
        marginRight: '3px',
        fill: 'gray'
    },
    labelStyle: {
        lineHeight: '15px',
        fontFamily: 'inherit',
        fontSize: '9pt',
        fontWeight: 'normal',
        color: '#000',
        paddingTop: '-1px',
        width: 'auto'
    },
};

//var termArr = [];
class ProfileAvailable extends React.Component {
    constructor(props) {
        super(props);

        var my = this.props.my;
        this.state = {
            loading: false,
            profileId: this.props.profileId,
            my: my,
            show: false,
            opt_available: [],
            available_status: "1",
            available_hour: "1",
        };
    }

    componentWillMount = () => {
        this.getAvailable();
    }

    componentDidMount = () => {
        this.setState({available_status: this.props.user.available_status+"", available_hour: this.props.user.available_hour+""})
    }

    componentWillReceiveProps = (nextProps) => {
        var my = nextProps.my;

        var loading = false;
        if (nextProps.profileId != this.props.profileId) {
            loading = true;
        }
        if (loading) {
            this.setState({
                loading: loading,
                profileId: nextProps.profileId,
                my: my,
            }, () => {
                this.getAvailable();
            });
        }
        else {
            this.setState({profileId: nextProps.profileId, my: my});
        }
    }

    getAvailable = () => {
        this.setState({loading: true});
        var url = "/code/apis.php?api=getParams&opt_param=available&order=value_param";
        var data = new FormData();
        axios.post(url, data)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState({ opt_available: response.data.data });
                }
                return response;
            }).catch(error => {
            this.setState({loading: false});
        });
    }

    handleChange = (event) => {
        this.setState({available_hour: event.target.value}, () => {
            this.handleSubmit()
        });
    }

    handleClick = (status, event) => {
        this.setState({available_status: status}, () => {
            this.handleSubmit()
        });
    }

    handleSubmit = () => {
        var data = new FormData();
        data.append('available_status', this.state.available_status);
        data.append('available_hour', this.state.available_hour);
        axios.post('/code/api_projects.php?api=updAvailable', data)
            .then(response => {
                if (response.data.status != 1) {
                    commonApi.showAlert("Please try again!");
                }
                return response;
            });
    }

    render() {
        var iconStyle = styles.iconStyle;
        var labelStyle = styles.labelStyle;
        var valDisabled = false
        if (this.state.available_status == "2") {
            iconStyle = grayStyles.iconStyle
            labelStyle = grayStyles.labelStyle
            valDisabled = true
        }
        if (this.state.my) {
            return (
                <div className={"page_course_box profile_content_wrapper"} style={{position: 'relative'}}>
                    <div className="title_box">
                        <div className="title">I am currently</div>
                    </div>
                    <div className="box-available">
                        <div className={this.state.available_status == "1" ? "left active" : "left"} onClick={this.handleClick.bind(this, 1)}>Available</div>
                        <div className={this.state.available_status == "2" ? "right active" : "right"} onClick={this.handleClick.bind(this, 2)}>Not Available</div>
                    </div>
                    <div className="work-time">
                        <RadioButtonGroup name="available" valueSelected={this.state.available_hour} onChange={this.handleChange.bind(this)}>
                            {this.state.opt_available.map((item, indx) => (
                                <RadioButton key={item.value} value={item.value} label={item.label} disabled={valDisabled} className="radioButton" iconStyle={iconStyle} labelStyle={labelStyle}/>
                            ))}
                        </RadioButtonGroup>
                    </div>
                </div>
            )
        }
        else {
            return <div>&nbsp;</div>;
        }
    }
}

export default ProfileAvailable;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_available.js
 **/